/*
  Boobie Bars × Think Pink — smooth scroll to the buy section.
  Any element with [data-boobie-scroll-to-buy="<target id>"] scrolls to that section
  (default `boobie-buy`) on click. Used by the donation bar, donation tracker,
  awareness and check CTAs. Links keep their href (#boobie-buy) as no-JS fallback.
*/
(() => {
  if (window.__pbBoobieScrollToBuy) return;
  window.__pbBoobieScrollToBuy = true;

  const desktopMq = window.matchMedia('(min-width: 992px)');

  const scrollToBuy = (targetId) => {
    const id = String(targetId || 'boobie-buy').replace(/^#/, '');
    const target = document.getElementById(id);
    if (!target) return false;

    const offset = 96;
    let top = target.getBoundingClientRect().top + window.scrollY - offset;

    // Mobile: the packshot comes first, so land on the product card instead,
    // centred in the space below the fixed nav (top-aligned if it is taller than that).
    const card = target.querySelector('.boobie-buy__card');
    if (card && !desktopMq.matches) {
      const nav = document.querySelector('.pb-unified-nav__fixed') || document.querySelector('.pb-unified-nav');
      const navBottom = nav ? Math.max(0, nav.getBoundingClientRect().bottom) : 0;
      const space = window.innerHeight - navBottom;
      const rect = card.getBoundingClientRect();
      const cardTop = rect.top + window.scrollY;
      top = rect.height < space - 24 ? cardTop - navBottom - (space - rect.height) / 2 : cardTop - navBottom - 12;
    }

    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    return true;
  };

  window.BoobieScrollToBuy = scrollToBuy;

  document.addEventListener('click', (event) => {
    const trigger = event.target instanceof Element ? event.target.closest('[data-boobie-scroll-to-buy]') : null;
    if (!trigger) return;
    // Target missing on this page: let a link follow its href as usual
    if (scrollToBuy(trigger.getAttribute('data-boobie-scroll-to-buy'))) event.preventDefault();
  });
})();
